import { render, staticRenderFns } from "./PersonalInfoCollectList.vue?vue&type=template&id=35faa9e6&scoped=true"
import script from "./PersonalInfoCollectList.vue?vue&type=script&lang=js"
export * from "./PersonalInfoCollectList.vue?vue&type=script&lang=js"
import style0 from "./PersonalInfoCollectList.vue?vue&type=style&index=0&id=35faa9e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35faa9e6",
  null
  
)

export default component.exports